var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgSurveyWealth01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 122,
    viewBox: "0 0 86 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M3.79005 1H42.6437C48.3685 1.00006 54.0304 2.19725 59.2672 4.51503C64.5041 6.8328 69.2006 10.2201 73.0564 14.4604L118 63.8927V121C114.402 121 110.844 120.248 107.553 118.791C104.262 117.335 101.311 115.206 98.8875 112.542L1.72732 5.68075C1.36321 5.27997 1.12314 4.78183 1.03626 4.24689C0.949373 3.71195 1.01943 3.16324 1.23792 2.66744C1.45641 2.17165 1.81391 1.75013 2.26698 1.45411C2.72005 1.1581 3.24918 1.00033 3.79005 1V1Z",
    stroke: "#00B74F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSurveyWealth01);
export default __webpack_public_path__ + "static/media/bg_survey_wealth_01.fb637acdeed5a17d4f9cc05cda993f43.svg";
export { ForwardRef as ReactComponent };